<div class="alarm-container" *ngIf="isEnabled('alarmLevel') && enableEdit">
    <div class="title">
        {{ title | translate }}
    </div>
    <mat-radio-group
        aria-labelledby="radio-group-label"
        class="radio-group"
        [(ngModel)]="alarm.alarmLevel"
        (ngModelChange)="changeAlarmLevel()"
    >
        <mat-radio-button
            class="radio-button"
            [value]="AlarmLevels.Alarm"
        >{{ALARM_ALARM | translate}}</mat-radio-button>
        <mat-radio-button
            class="radio-button"
            [value]="AlarmLevels.Warning"
        >{{ALARM_WARNING | translate}}</mat-radio-button>
        <mat-radio-button
            class="radio-button"
            [value]="AlarmLevels.Caution"
        >{{ALARM_CAUTION | translate}}</mat-radio-button>
    </mat-radio-group>
</div>

<!-- Input Fields -->
<div class="input-container" *ngIf="enableEdit">
    <!-- Set Point -->
    <div *ngIf="isEnabled('setPoint')" class="input-text-wrapper">
        <app-text-input
            name="setPoint"
            label="forms.channel.alarm.alarm-setting-setpoint"
            [value]="alarm?.setPoint"
            (inputChange)="onInputChange($event)"
            [unit]="measurementUnits"
            [inputErrorMessage]="validationErrors?.setPoint?.message"
        >
        </app-text-input>
    </div>

    <!-- Timer -->
    <div *ngIf="isEnabled('timer')" class="input-text-wrapper">
        <app-text-input
            name="timer"
            label="forms.channel.alarm.alarm-setting-timer"
            [value]="alarm?.setPoint"
            (inputChange)="onInputChange($event)"
            [inputErrorMessage]="validationErrors?.setPoint?.message"
        >
        </app-text-input>
    </div>

    <!-- Delay -->
    <div *ngIf="isEnabled('delayTimer')" class="input-text-wrapper">
        <app-text-input
            name="delay"
            unit="forms.channel.alarm.alarm-setting-sec"
            label="forms.channel.alarm.alarm-setting-delay"
            [value]="alarm.delayTimer"
            (inputChange)="onInputChange($event)"
            [inputErrorMessage]="validationErrors?.delayTimer?.message"
        >
        </app-text-input>
    </div>

    <!-- EXT. G. -->
    <div *ngIf="isEnabled('alarmGroupNo')" class="input-text-wrapper">
        <app-text-input
            name="extG"
            label="forms.channel.alarm.alarm-setting-ext-g"
            [value]="alarm.alarmGroupNo"
            (inputChange)="onInputChange($event)"
            [inputErrorMessage]="validationErrors?.alarmGroupNo?.message"
        >
        </app-text-input>
    </div>

    <!-- G. REP1 -->
    <div *ngIf="isEnabled('reposeGroup1No')" class="input-text-wrapper">
        <app-text-input
            name="gRep1"
            label="forms.channel.alarm.alarm-setting-g-rep1"
            [value]="alarm.reposeGroup1No"
            (inputChange)="onInputChange($event)"
            [inputErrorMessage]="validationErrors?.reposeGroup1No?.message"
        >
        </app-text-input>
    </div>

    <!-- G. REP2 -->
    <div *ngIf="isEnabled('reposeGroup2No')" class="input-text-wrapper">
        <app-text-input
            name="gRep2"
            label="forms.channel.alarm.alarm-setting-g-rep2"
            [value]="alarm.reposeGroup2No"
            (inputChange)="onInputChange($event)"
            [inputErrorMessage]="validationErrors?.reposeGroup2No?.message"
        >
        </app-text-input>
    </div>

    <!-- M. REP -->
    <div *ngIf="isEnabled('manualReposeFlag')" class="toggle-wrapper">
        <label class="switch">
            <input
                type="checkbox"
                [(ngModel)]="alarm.manualReposeFlag"
            />
            <span class="slider"></span>
        </label>
    </div>
</div>

<div class="alarm-check-container" *ngIf="enableEdit">
    <div class="check-title">{{ "channel.settings.alarm.check.title" | translate }}</div>
    <div class="description-container">
        <span class="description" [class.check-enable]="checkSetPoint" *ngIf="isEnabled('setPoint')">
            <mat-icon 
                class="check-icon" 
                [svgIcon]="checkSetPoint ? 'check' : 'cancel-close'"
                [class.check-enable]="checkSetPoint"
            ></mat-icon>
            {{ "forms.channel.alarm.alarm-setting-setpoint" | translate }}
        </span>
        <span class="description" [class.check-enable]="checkTimer" *ngIf="isEnabled('timer')">
            <mat-icon 
                class="check-icon" 
                [svgIcon]="checkTimer ? 'check' : 'cancel-close'"
                [class.check-enable]="checkTimer"
            ></mat-icon>
            {{ "forms.channel.alarm.alarm-setting-timer" | translate }}
        </span>
        <span class="description" [class.check-enable]="checkDelay">
            <mat-icon 
                class="check-icon" 
                [svgIcon]="checkDelay ? 'check' : 'cancel-close'"
                [class.check-enable]="checkDelay"
            ></mat-icon>
            {{ "forms.channel.alarm.alarm-setting-delay" | translate }}
        </span>
        <span class="description" [class.check-enable]="checkAlarmServerity">
            <mat-icon 
                class="check-icon" 
                svgIcon="cancel-close"
                [svgIcon]="checkAlarmServerity ? 'check' : 'cancel-close'"
                [class.check-enable]="checkAlarmServerity"
            ></mat-icon>
            {{ "channel.settings.alarm.alarm-level-check" | translate }}
        </span>
    </div>
    <div class="buttons">
        <div class="alarm-enable-buttons">
            <div
                class="enable-button button"
                [class.disabled]="editCheckExistDelayButtonDisabled()"
                (click)="saveButtonClick(true)"
            >
                {{ "channel.settings.form.save-enable-button" | translate }}
            </div>
            <div
                class="disable-button button"
                [class.disabled]="editCheckExistDelayButtonDisabled()"
                (click)="saveButtonClick(false)"
                *ngIf="!isDigital()"
            >
                {{ "channel.settings.form.save-disabled-button" | translate }}
            </div>
        </div>
        <div
            class="cancel-button button"
            (click)="alarmCancelButtonClick()"
        >
            {{ "forms.channels.custom-group.buttons.cancel" | translate }}
        </div>
    </div>
</div>

<div class="preview-container" *ngIf="!enableEdit">
    <div class="preview-title-container">
        <span class="title">{{ title | translate }}</span>
        <span class="enable" [class.disabled]="!alarm.enable">
            {{ 
                alarm.enable ? 
                    ("forms.channel.alarm.alarm-setting-enable" | translate) : 
                    ("forms.channel.alarm.alarm-setting-disable" | translate) 
            }}
         </span>
        <span class="alarm-level">{{ alarmLevelText | translate }}</span>
    </div>
    <div class="alarm-value-container">
        <div class="preview-wrapper" *ngIf="isEnabled('setPoint')">
            <span class="value-name">{{ "forms.channel.alarm.alarm-setting-setpoint" | translate }}</span>
            <span class="value">{{ alarm?.setPoint }} {{ measurementUnits }}</span>
        </div>
        <div class="preview-wrapper" *ngIf="isEnabled('timer')">
            <span class="value-name">{{ "forms.channel.alarm.alarm-setting-timer" | translate }}</span>
            <span class="value">{{ alarm?.timer }}</span>
        </div>
        <div class="preview-wrapper" *ngIf="isEnabled('delayTimer')">
            <span class="value-name">{{ "forms.channel.alarm.alarm-setting-delay" | translate }}</span>
            <span class="value">{{ alarm.delayTimer }} {{ "forms.channel.alarm.alarm-setting-sec" | translate }}</span>
        </div>
        <div class="preview-wrapper" *ngIf="isEnabled('alarmGroupNo')">
            <span class="value-name">{{ "forms.channel.alarm.alarm-setting-ext-g" | translate }}</span>
            <span class="value">{{ alarm.alarmGroupNo }}</span>
        </div>
        <div class="preview-wrapper" *ngIf="isEnabled('reposeGroup1No')">
            <span class="value-name">{{ "forms.channel.alarm.alarm-setting-g-rep1" | translate }}</span>
            <span class="value">{{ alarm.reposeGroup1No }}</span>
        </div>
        <div class="preview-wrapper" *ngIf="isEnabled('reposeGroup2No')">
            <span class="value-name">{{ "forms.channel.alarm.alarm-setting-g-rep2" | translate }}</span>
            <span class="value">{{ alarm.reposeGroup2No }}</span>
        </div>
        <div class="preview-wrapper" *ngIf="isEnabled('manualReposeFlag')">
            <span class="value-name">{{ "forms.channel.alarm.alarm-setting-m-rep" | translate }}</span>
            <span class="value">
                {{ 
                    (alarm.manualReposeFlag ? 
                            "forms.channel.alarm.alarm-setting-enable" : 
                            "forms.channel.alarm.alarm-setting-disable") | translate 
                }}
            </span>
        </div>
    </div>
    <div class="edit-container" *ngIf="userPermission">
        <span class="edit-text" (click)="editTextClick()">{{ "forms.channel.alarm.button.edit"| translate }} {{ title | translate }}</span>
    </div>
</div>